import React from 'react';

import { OptionCheckmark } from '@/components/OptionCheckmark';
import { UiTypography } from '@/components/ui/Typography';
import { webCampaign } from '@/modules/webCampaign';

import {
  OptionContentStyles,
  OptionHeaderLabelStyles,
  OptionHeaderStyles,
  OptionsStyles,
  OptionStyles,
} from './Options.styles';

export const Options: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return <OptionsStyles className="options-list">{children}</OptionsStyles>;
};

export const Option: React.FC<{
  children?: React.ReactNode;
  onClick?: () => void;
  selected: boolean;
  label: string;
  labelIcon: React.ReactNode;
  theme?: 'light' | 'dark' | 'dark-forest' | 'domination';
}> = ({ children, onClick, selected, label, labelIcon, theme }) => {
  return (
    <OptionStyles
      onClick={onClick}
      theme={webCampaign.getStaticTheme()}
      className="option"
    >
      <OptionHeaderStyles>
        <OptionHeaderLabelStyles>
          <OptionCheckmark checked={selected} theme={theme} />
          <UiTypography variant="body-medium" color="white-static">
            {label}
          </UiTypography>
        </OptionHeaderLabelStyles>
        {labelIcon}
      </OptionHeaderStyles>

      <OptionContentStyles selected={selected}>{children}</OptionContentStyles>
    </OptionStyles>
  );
};
